/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonPersonidResumeeEnrollments200,
  GetApiV1PersonPersonidResumeeEnrollments400,
  GetApiV1PersonPersonidResumeeEnrollments401,
  GetApiV1PersonPersonidResumeeEnrollments500,
  GetApiV1PersonPersonidResumeeEnrollmentsPathParams,
  GetApiV1PersonPersonidResumeeEnrollmentsQueryResponse,
} from "../../types/personResumeeController/GetApiV1PersonPersonidResumeeEnrollments.ts";
import { studentResumeeEnrollmentsTabViewModelSchema } from "../studentResumeeEnrollmentsTabViewModelSchema.ts";

export const getApiV1PersonPersonidResumeeEnrollmentsPathParamsSchema =
  z.object({
    personId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1PersonPersonidResumeeEnrollmentsPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonPersonidResumeeEnrollments200Schema = z.lazy(
  () => studentResumeeEnrollmentsTabViewModelSchema,
) as unknown as ToZod<GetApiV1PersonPersonidResumeeEnrollments200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1PersonPersonidResumeeEnrollments400Schema =
  z.any() as unknown as ToZod<GetApiV1PersonPersonidResumeeEnrollments400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonPersonidResumeeEnrollments401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonPersonidResumeeEnrollments401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonPersonidResumeeEnrollments500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonPersonidResumeeEnrollments500>;

export const getApiV1PersonPersonidResumeeEnrollmentsQueryResponseSchema =
  z.lazy(
    () => getApiV1PersonPersonidResumeeEnrollments200Schema,
  ) as unknown as ToZod<GetApiV1PersonPersonidResumeeEnrollmentsQueryResponse>;
